import {
  ChangeDetectionStrategy,
  Component,
  inject,
  input,
  OnDestroy,
  OnInit,
} from "@angular/core";
import { PaymentDetails } from "../shared/models/paymentdetails";
import { WhiteLabelInfo } from "src/app/core/models/model";
import { PaymentService } from "../shared/services/payment.service";
import { takeUntil } from "rxjs/operators";
import { Subject } from "rxjs";
import { ToastrService } from "ngx-toastr";
import { environment } from "src/environments/environment";
import posthog from "posthog-js";

interface OpayInitPayload {
  productName: string;
  reference: string;
  amount: string;
  country: string;
  returnUrl: string;
  callbackUrl: string;
  cancelUrl: string;
  narration: string;
  customerId: string;
  // accountNumber: string;
  bankName: string;
}
@Component({
  selector: "app-banks",
  templateUrl: "./banks.component.html",
  styleUrl: "./banks.component.css",
  standalone: false,
})
export class BanksComponent implements OnInit, OnDestroy {
  paymentReference = input.required<string>();
  paymentDetails = input.required<PaymentDetails>();
  whiteLabelInfo = input<WhiteLabelInfo | null>(null);

  checkOutEnvURL = environment.checkOutURL;

  #payService = inject(PaymentService);
  #toastr = inject(ToastrService);

  destroy$ = new Subject();
  banks: any[];

  showModal: boolean = false;
  errorMessage: string = "";

  //"../../../../../assets/rexpay/opay-img.png"

  ngOnInit(): void {
    this.#payService
      .getBanksList()
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (res) => {
          // this.banks = res.map((item) => {
          //   if (item.includes("MONO")) {
          //     return { name: "MONO", value: item };
          //   }
          //   return { name: item, value: item };
          // });
          this.banks = res
            .map((method) => {
              const logos: { [key: string]: string } = {
                MASTER_CARD_MONO: "../../../assets/rexpay/mono.svg",
                OPAY: "../../../assets/rexpay/opay-img.png",
              };

              return {
                name: method.includes("MONO") ? "MONO" : method, // Formatting name for display
                value: method,
                logo: logos[method] || "assets/rexpay/default.svg", // Default logo if not found
              };
            })
            .filter((bank) => bank.name === "MONO");
        },
      });
  }

  private bankEventProps(bankName: string) {
    return {
      bankName,
      clientId: this.paymentDetails().clientId,
      amount: this.paymentDetails().amount,
      currency: this.paymentDetails().currency,
      reference: this.paymentDetails().referenceId,
    };
  }

  makePayment(bankName: string) {
    this.showModal = true;
    this.errorMessage =
      "Payment option unavailable. Please choose another method.";
    return;
    const amountPlusFees =
      this.paymentDetails().amount + (Number(this.paymentDetails().fees) ?? 0);

    posthog.capture("bank_payment_initiated", this.bankEventProps(bankName));

    if (bankName === "MASTER_CARD_MONO" && this.paymentDetails().amount < 200) {
      posthog.capture("bank_validation_error", {
        ...this.bankEventProps(bankName),
        reason: "Minimum amount for Mono is NGN200",
      });
      this.#toastr.error("Minimum amount for transactions with Mono is NGN200");
      return;
    }
    const encryptedReturnUrlParams = btoa(
      `${this.paymentDetails().referenceId}/${
        this.paymentDetails().amount
      }/pending`,
    );
    const encryptedCancelUrlParams = btoa(
      `${this.paymentDetails().referenceId}/${
        this.paymentDetails().amount
      }/failed`,
    );
    let request: OpayInitPayload = {
      productName: this.paymentDetails().clientId, // is clientID for now
      reference: this.paymentDetails().referenceId,
      amount: String(amountPlusFees),
      country: "NG", //this.paymentDetails().country, // NG not NGA
      // returnUrl: `${this.checkOutEnvURL}/checkout/success/${this.paymentDetails().amount}/success/${btoa("Payment already completed")}`,
      // callbackUrl: `${this.checkOutEnvURL}/checkout/success/${amountPlusFees}/success/${btoa("Payment already completed")}`,
      // cancelUrl: `${this.checkOutEnvURL}/failure/${amountPlusFees}/${this.paymentDetails().referenceId}/${btoa("Payment already completed")}`,
      returnUrl: `${this.checkOutEnvURL}/banks/${encryptedReturnUrlParams}`,
      callbackUrl: `${this.checkOutEnvURL}/banks/${encryptedReturnUrlParams}`,
      cancelUrl: `${this.paymentDetails().paymentUrl}`,
      narration:
        this.paymentDetails()["metadata"].email ??
        this.paymentDetails()["userId"],
      customerId:
        this.paymentDetails()["metadata"].email ??
        this.paymentDetails()["userId"],
      bankName: bankName,
    };

    this.#payService
      .initiateBankTransaction(request)
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (res) => {
          if (res.responseCode === "00") {
            posthog.capture("bank_redirect_initiated", {
              ...this.bankEventProps(bankName),
              responseCode: res.responseCode,
            });
            document.location.href = res.cashierUrl;
          }
        },
        error: (err) => {
          posthog.capture("bank_payment_error", {
            ...this.bankEventProps(bankName),
            responseCode: err?.error?.responseCode,
            reason: err?.error?.responseMessage,
          });
          this.#toastr.error(
            err?.error?.responseMessage ??
              "Unable to complete your request at the moment, please try again",
          );
        },
      });
  }

  ngOnDestroy() {
    this.destroy$.next(true);
    this.destroy$.unsubscribe();
  }
}
